import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { ProjectLocationsTab } from "@/components/locations/ProjectLocationsTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import type { DBProjectLocation } from "@/lib/db-types";

/** /prosjekter/:id/lokasjoner (VIB-2940), bak feature_locations. */
export default function LocationsTabPage() {
  const { project, isAdmin, isProductionLead, activeUserId } = useProjectDetailContext();
  const enabled = useFeatureFlag("feature_locations");
  if (!enabled) return <p className="text-muted-foreground">Ikke tilgjengelig ennå.</p>;
  // Samme regel som RLS: den som la til, PL, rådgiver og admin.
  const canManage = (link: DBProjectLocation) =>
    isAdmin || isProductionLead || project.advisor_id === activeUserId || link.created_by === activeUserId;
  return (
    <ErrorBoundary>
      <ProjectLocationsTab projectId={project.id} locked={project.project_status === "completed"} canManage={canManage} />
    </ErrorBoundary>
  );
}
